module.exports = __webpack_public_path__ + "img/cockroach_bluechart01.20cd5e20.jpg";